/**
 * Конвертирует размер в байтах в более удобные единицы (КБ или МБ).
 * Если размер меньше 1 КБ, возвращается в байтах (B).
 * Если больше или равен 1 КБ, но меньше 1 МБ, возвращается в килобайтах (KB).
 * Если больше или равен 1 МБ, возвращается в мегабайтах (MB).
 *
 * @param {number} sizeInBytes - Размер в байтах, который необходимо конвертировать.
 * @returns {string} Строка с размером, конвертированным в соответствующую единицу.
 *
 * @example
 * convertBytes(1048576); // "1 MB"
 * convertBytes(2048);    // "2 KB"
 * convertBytes(512);     // "512 B"
 */

export function convertBytes(value: number) {
  if (value >= 1024 ** 2)
    return `${value / (1024 ** 2)} мб`

  else if (value >= 1024)
    return `${value / 1024} кб`

  else
    return `${value} б`
}
